import { render, staticRenderFns } from "./WalletRechargeDeduction.vue?vue&type=template&id=117e5f8c&"
import script from "./WalletRechargeDeduction.vue?vue&type=script&lang=js&"
export * from "./WalletRechargeDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports